<!--
 * @Descripttion: 
 * @version: 
 * @Author: 
 * @Date: 2023-07-15 19:09:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-01-08 15:45:58
-->
<template>
  <div class="withdraw-usdt" style="position:relative">
    <!-- 横幅广告容器 -->
    <div class="form-banner">
        <div class="banner-slogan">
         {{ $t('WithdrawUSDT.WithdrawPageBannerTitle') }}
          <span class="second-line">{{ $t('WithdrawUSDT.WithdrawPageBannerDesc') }}</span>
        </div>
    </div>
    <div class="c-wrper">
      <el-card class="box-card">
        
        <el-alert style="margin-top:20px;" type="warning" show-icon center>
          <template slot="title">
            <!-- <div style="font-weight: bold">{{ $t("WithdrawUSDT.NewTip") }}</div> -->
            <div style="font-weight: bold">{{ $t("WithdrawUSDT.Tip2") }}</div>
            <div style="font-weight: bold">{{ $t("WithdrawUSDT.Tip3") }}</div>
          </template>
        </el-alert>
        <div class="fom-box" style="width: 570px; margin: 0 auto">
          <div style="padding: 15px 5px; border-bottom: 1px solid #eee">
            <div style="display:flex;gap: 10px;margin-top:10px;align-items:center;padding-bottom:6px;border-bottom:1px solid #eee;">
              <span>{{ $t('WithdrawUSDT.AccountBalance') }}</span>
              <span style="font-size:20px;font-weight:bold;">${{ account_balance }}</span>
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: flex-start;
                gap: 10px;
                margin-top: 10px;
                margin-bottom: 10px;
              "
            >
              <div>
                {{ $t("WithdrawUSDT.WithdrawAddress") }}
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('WithdrawUSDT.WithdrawAddressTitleTip')"
                  placement="top"
                >
                  <i
                    class="el-icon-question"
                    style="
                      font-size: 18px;
                      color: #e6a23c;
                      vertical-align: -2px;
                    "
                  ></i>
                </el-tooltip>
              </div>
              <!-- <span>{{ wAddr }}</span> -->
              <div class="wd-btnbox">
                <el-button
                  @click="openAllAddressDialog"
                  size="small"
                  type="primary"
                  >{{ $t("WithdrawUSDT.SelectBtn") }}</el-button
                >
                <el-button
                  @click="openAddAddressDialog"
                  size="small"
                  type="success"
                  >{{ $t("WithdrawUSDT.AddBtn") }}</el-button
                >
              </div>
            </div>
            <div v-show="addressNoneTip" style="
              color: #e55353;
              font-size: 13px;
              font-weight:bold;
              text-align: left;
              margin-top: 5px;
            ">{{ $t('WithdrawUSDT.AddressNoneTip') }}</div>
            <div v-if="wAddr != ''">
              <div style="margin-bottom: 5px;display:flex;align-items:center;gap:20px;justify-content:space-between;">
                <!-- <span>{{ $t("WithdrawUSDT.ListAddress") }}: </span> -->
                <span style="flex:1;font-weight:bold;font-size:18px;color:#666;">{{ wAddr }}</span>
                <span style="flex:1;text-align:center;font-weight:bold;font-size:18px;color:#666;">{{ wAddrTag }}</span>
              </div>
              
            </div>
          </div>
          <div class="fitem" v-if="wAddr != ''">
            <div>{{ $t("WithdrawUSDT.DailyWithdrawalLimit") }}
              <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('WithdrawUSDT.Limit24')"
                  placement="top"
                >
                  <i
                    class="el-icon-question"
                    style="
                      font-size: 18px;
                      color: #e6a23c;
                      vertical-align: -2px;
                    "
                  ></i>
                </el-tooltip>
            </div>
            <div>{{ limit_24h }} 
              <span v-if="getLa == 'en-US'">({{ available_limit_24h }}{{$t('WithdrawUSDT.LeftEN')}})</span>
              <span v-else>({{$t('WithdrawUSDT.Left')}}{{ available_limit_24h }})</span>
            </div>
          </div>
          <div class="fitem" v-if="wAddr != ''">
            <div>{{ $t("WithdrawUSDT.DailyWithdrawalAmountLimit") }}
              <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('WithdrawUSDT.Limit24')"
                  placement="top"
                >
                  <i
                    class="el-icon-question"
                    style="
                      font-size: 18px;
                      color: #e6a23c;
                      vertical-align: -2px;
                    "
                  ></i>
                </el-tooltip>
            </div>
            <div>${{ limit_amount_24h }}
              <span v-if="getLa == 'en-US'">({{ available_limit_amount_24h }}{{$t('WithdrawUSDT.LeftEN')}})</span>
              <span v-else>({{$t('WithdrawUSDT.Left')}}{{ available_limit_amount_24h }})</span>
            </div>
          </div>
          <div class="fitem">
            <div class="">{{ $t("WithdrawUSDT.WithdrawAmount") }}</div>
            <CInput
              v-model="wBalance"
              :invalid-feedback="errorBackBala"
              :is-valid="validatorBala"
              class="inp"
              type="text"
            />
          </div>
          <div class="fitem">
            <div class="">{{ $t("WithdrawUSDT.WithdrawalFee") }}</div>
            <!-- <div class="vals form-group acvals">3%</div> -->
            <div class="vals form-group acvals">{{ wFe }}</div>
          </div>
          <div class="fitem">
            <div class="">{{ $t("WithdrawUSDT.ReceivedUsdtNew") }}</div>
            <div class="vals form-group acvals">{{ reBalance }}</div>
          </div>
          <p
            v-if="flagsReBalance"
            style="
              color: #e55353;
              font-size: 12px;
              text-align: right;
              margin-top: 5px;
            "
          >
            {{ errorReBalance }}
          </p>
          <div class="fitem" style="justify-content: center">
            <div style="text-align: center; margin-top: 2rem">
              <button
                @click="submitUSDT"
                style="width: 188px"
                class="btn custer sbtn"
                type="button"
              >
                {{ $t("WithdrawUSDT.Submit") }}
              </button>
            </div>
          </div>
        </div>
      </el-card>
      <!-- <el-card class="box-card">
        <el-alert
          type="warning"
          show-icon
        >
        <template slot="title">
          <div style="font-weight:bold">{{$t('WithdrawUSDT.Tip')}}</div>
          <div style="font-weight:bold">{{$t('WithdrawUSDT.Tip2')}}</div>
        </template>
        </el-alert>
        <div class="fom-box">
          <div class="fitem">
            <div class="flb">{{ $t('WithdrawUSDT.WithdrawAddress') }}</div>
            <CInput class="inp" v-model="wAddr" oninput="value=value.replace(/[^a-zA-Z0-9]/g, '')"
                  type="text"
                  :invalid-feedback="errorBackAddress"
                  :is-valid="validatorAddress"
                  valid-feedback="" />
            <span class="tip">Tron chain ONLY</span>
          </div>
          <div class="fitem">
            <div class="flb">{{ $t('WithdrawUSDT.WithdrawAmount') }}</div>
            <CInput v-model="wBalance" :invalid-feedback="errorBackBala" :is-valid="validatorBala" class="inp" type="text" />
          </div>
          <div class="fitem">
            <div class="flb">{{ $t('WithdrawUSDT.WithdrawCurrency') }}</div>
            <div class="vals form-group acvals">USDT</div>
          </div>
          <div class="fitem">
            <div class="flb">{{ $t('WithdrawUSDT.Rate') }}</div>
            <div class="vals form-group acvals">1</div>
          </div>
          <div class="fitem">
            <div class="flb">{{ $t('WithdrawUSDT.WithdrawalFee') }}</div>
            <div class="vals form-group acvals">{{ wFe }}</div>
          </div>
          <div class="fitem">
            <div class="flb">{{ $t('WithdrawUSDT.ReceivedUsdt') }}</div>
            <div class="vals form-group acvals">{{ reBalance }}</div>
          </div>
          <div class="fitem" style="justify-content: center">
            <div style="text-align: center; margin-top: 2rem">
              <button
                @click="submitUSDT"
                style="width: 328px"
                class="btn custer sbtn"
                type="button"
              >
                {{ $t('WithdrawUSDT.Submit') }}
              </button>
            </div>
          </div>
        </div>
      </el-card> -->
    </div>
    <!-- 選擇地址窗口 -->
    <el-dialog
      custom-class="brd"
      :close-on-click-modal="false"
      :title="$t('WithdrawUSDT.WithdrawAddress')"
      :visible.sync="dialogAddressVisible"
    >
      <AddressTable
        :allAddressData="allAddressData"
        :addressTableLoading="addressTableLoading"
        :isUseSelect="true"
        @emitSelected="clickSelected"
        @emitDeleted="clickDeleted"
        @emitInitListData="initAllAddressApi"
      ></AddressTable>
    </el-dialog>
    <!-- 新增地址窗口 -->
    <el-dialog
      width="50%"
      custom-class="brd"
      :close-on-click-modal="false"
      :title="$t('WithdrawUSDT.AddDialogTitle')"
      :visible.sync="dialogAddAddressVisible"
      @close="closeAddDialog"
    >
      <div class="addaddress-box">
        <div v-if="step1" class="step1-box">
          <div style="margin-bottom: 20px">
            <div style="margin-bottom: 8px">
              <sup
                style="
                  color: red;
                  margin-right: 5px;
                  font-size: 14px;
                  vertical-align: bottom;
                "
                >*</sup
              >{{ $t("WithdrawUSDT.NewTronAddress") }}
            </div>
            <CInput
              v-model="ruleForm.address"
              oninput="value=value.replace(/[^a-zA-Z0-9]/g, '')"
              type="text"
              :invalid-feedback="errorBackAddress"
              :is-valid="validatorAddress"
              valid-feedback=""
            />
          </div>
          <div style="margin-bottom: 20px">
            <div style="margin-bottom: 8px">
              <sup
                style="
                  color: red;
                  margin-right: 5px;
                  font-size: 14px;
                  vertical-align: bottom;
                "
                >*</sup
              >{{ $t("WithdrawUSDT.ListTag") }}
            </div>
            <CInput
              v-model="ruleForm.tag"
              type="text"
              :invalid-feedback="errorBackTag"
              :is-valid="validatorTag"
              valid-feedback=""
              style="margin-bottom:5px"
            />
            <div v-show="visiTagMessage" style="color:#e55353;font-size:80%;">{{ tagErrorMessage }}</div>
          </div>
          <div>
            <el-tabs v-model="activeNameResetPwd" @tab-click="handleCommand">
              <el-tab-pane :label="$t('LoginFields.UserEmailRecover')" name="em">
                <div style="margin-bottom: 20px">
                  <div style="margin-bottom: 8px">
                    <sup
                      style="
                        color: red;
                        margin-right: 5px;
                        font-size: 14px;
                        vertical-align: bottom;
                      "
                      >*</sup
                    >{{ $t("avatarSelect.EmailCode") }}
                  </div>
                  <div class="fl" style="padding:5px">
                      
                      <div style="width:100%">
                          <CInput style="margin-bottom:5px;" autocomplete="username" v-model="ruleForm.code"></CInput>
                          <div v-show="visiEmailMessage" style="color:#e55353;font-size:80%;">{{ emailErrorMessage }}</div>
                      </div>
                      <div>
                        <CButton
                          color="success"
                          style="margin-bottom: 1rem;width:100px"
                          block
                          :disabled="dib"
                          @click="reqCode"
                          >{{ cgan == "" ? getVc : cgan }}</CButton
                        >
                      </div>
                  </div>
                </div>
                
              </el-tab-pane>
              <el-tab-pane :label="$t('LoginFields.UserAuthenticator')" name="gm">
                <div style="margin-bottom: 8px">
                  <sup
                    style="
                      color: red;
                      margin-right: 5px;
                      font-size: 14px;
                      vertical-align: bottom;
                    "
                    >*</sup
                  >{{ $t("LoginFields.UserAuthenticator") }}
                </div>
                <div style="padding:5px">
                  <CInput :placeholder="$t('LoginFields.UserGoogleAuthInputPlacholder')" autocomplete="googlecode" v-model="ruleForm.googleCode"></CInput>
                  <div v-show="visiGoogleMessage" style="color:#e55353;font-size:80%;">{{ googleErrorMessage }}</div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div v-else class="step2-box">
          <div>
            <el-alert
              :title="$t('WithdrawUSDT.EnterMissing4AddressCharacters')"
              :closable="false"
              center
            >
            <div slot="title" style="font-weight:bold;font-size:18px;">{{ $t('WithdrawUSDT.EnterMissing4AddressCharacters') }}</div>
            </el-alert>
          </div>
          <div class="address-container">
            <span class="address-part">{{ addressPrefix }}</span>
            <div class="input-boxes">
              <input
                v-for="(char, index) in inputChars"
                :key="index"
                v-model="inputChars[index]"
                @input="onInput(index)"
                @keydown="handleKeyDown($event, index)"
                ref="charInputs"
                class="char-input"
                maxlength="1"
                type="text"
              />
            </div>
            <span class="address-part">{{ addressSuffix }}</span>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div v-if="step1">
          <el-button size="small" @click="cancelAddAddress">{{
            $t("WithdrawUSDT.Cancel")
          }}</el-button>
          <el-button
            size="small"
            @click="toNext"
            style="background-color: #00bea4; color: #fff"
            >{{ $t("WithdrawUSDT.Next") }}</el-button
          >
        </div>
        <div v-else>
          <el-button
            size="small"
            @click="submitAddAddress"
            style="background-color: #00bea4; color: #fff"
            >{{ $t("WithdrawUSDT.Submit") }}</el-button
          >
        </div>
      </div>
    </el-dialog>
    <AliyunCaptchaGuard
      ref="emailCodeCaptchaGuard"
      cache-key="withdraw-usdt-get-email-code-captcha"
    />
    <AliyunCaptchaGuard
      ref="addWithdrawAddressCaptchaGuard"
      cache-key="withdraw-usdt-add-withdraw-address-captcha"
    />
    <AliyunCaptchaGuard
      ref="withdrawCaptchaGuard"
      cache-key="withdraw-usdt-withdraw-captcha"
    />
  </div>
</template>

<script>
import {
  withdraw,
  allUSDTAddress,
  deleteUSDTAddress,
  addUSDTAddress,
  verifyUSDTAddress,
  getAccountBalance
} from "../../api/http";
import AddressTable from "../../components/AddressTable.vue";
import AliyunCaptchaGuard from "@/components/AliyunCaptchaGuard.vue";
import { Loading } from "element-ui";
export default {
  components: { AddressTable, AliyunCaptchaGuard },
  data() {
    return {
      wAddr: "", // 當前的提現地址
      wAddrTag: '',
      wBalance: null, // 提現金額
      errorBackAddress: "",
      flags: false,
      flagsBala: false,
      errorBackBala: "",
      wFe: "3%",
      errorReBalance: "",
      errorBackTag: "",
      dialogAddressVisible: false,
      limit_24h: "",
      limit_amount_24h: "",
      addressTableLoading: false,
      flagsReBalance: false,
      dialogAddAddressVisible: false,
      step1: true,
      errorBackTag: "",
      tagFlag: false,
      // 标准Tron地址示例 (34位)
      fullAddress: "TV6MuMXfmLbBqPZvBHdwFsDnQeVfnmiuSi",
      // 需要用戶輸入的中間字符数量
      hiddenCharsCount: 4,
      // 用户輸入的字符
      inputChars: ["", "", "", ""],
      message: "",
      isSuccess: false,
      // 存储隐藏的字符
      hiddenChars: "",
      addr_id: "",
      masked_addr: "", // 帶有*號字符
      ruleForm: {
        address: "",
        tag: "",
        code: '',
        googleCode: ''
      },
      allAddressData: [
        // {
        //   address: '2222222223',
        //   tag: '222c'
        // }
      ],
      account_balance: 0,
      available_limit_24h: 0, // 剩餘提現次數
      available_limit_amount_24h: 0, // 剩餘提現金額
      addressNoneTip: false,
      activeNameResetPwd: 'em',
      authType: this.$t('LoginFields.UserEmailRecover'),
      showGoogleCodeInput: false,
      dib: false,
      timer: null,
      timerNum: 60,
      cgan: '',
      tagErrorMessage: '',
      visiTagMessage: false,
      emailErrorMessage: '',
      visiEmailMessage: false,
      googleErrorMessage: '',
      visiGoogleMessage: false
    };
  },
  created() {
    // this.calculateHiddenPart()
    this.initAccountBalance()
    this.initAllAddressApi();
  },
  computed: {
    reBalance() {
      // return (Number(this.wBalance) * 0.97).toFixed(2);
      if (this.wFe == "3% + 3") {
        return (Number(this.wBalance) * 0.97 - 3).toFixed(2);
      } else {
        return (Number(this.wBalance) * 0.97).toFixed(2);
      }
    },
    // 地址前綴部分
    addressPrefix() {
      // return this.fullAddress.substring(0, this.hiddenStartIndex);
      return this.extractParts(this.masked_addr).before;
    },
    // 地址後綴部分
    addressSuffix() {
      // return this.fullAddress.substring(this.hiddenEndIndex);
      return this.extractParts(this.masked_addr).after;
    },
    // 判斷是否所有字符都已輸入
    isInputComplete() {
      return this.inputChars.every((char) => char.length === 1);
    },
    // 计算隐藏部分的起始索引 - 针对34位地址，取中间位置
    hiddenStartIndex() {
      // 对于34位地址，隐藏第15-18位字符（基于0索引为14-17）
      return 15;
    },
    // 计算隐藏部分的结束索引
    hiddenEndIndex() {
      return this.hiddenStartIndex + this.hiddenCharsCount;
    },
    // 獲取當前語言
    getLa() {
      // return localStorage.getItem("lang")
      let la = this.$i18n.locale
      if(la == 'en') {
        return 'en-US'
      }else {
        return this.$i18n.locale
      }
    },
    getVc: {
      get() {
        return this.$t("RegisterFields.SendCode2");
      },
      set(v) {
        console.log("vvv==>", v);
        this.cgan = v;
      },
    },
  },
  watch: {
    wBalance(val) {
      if (val < 100) {
        this.wFe = "3% + 3";
      } else {
        this.wFe = "3%";
      }
    },
    reBalance(val) {
      let reg = /^(\+)?\d+(\.\d+)?$/;
      if (reg.test(val)) {
        this.errorReBalance = "";
        this.flagsReBalance = false;
      } else {
        this.errorReBalance = this.$t("BankWithdrawal.InvalidAmount");
        this.flagsReBalance = true;
      }
    },
    wAddr(val) {
      if(val == '') {
        this.addressNoneTip = true
      } else {
        this.addressNoneTip = false
      }
    },
    'ruleForm.tag': {
      handler(val) {
        if(val === '') {
          this.visiTagMessage = true
        } else {
          this.visiTagMessage = false
        }
      },
      immediate: true
    },
    'ruleForm.code': {
      handler(val) {
        if(val === '') {
          this.visiEmailMessage = true
        } else {
          this.visiEmailMessage = false
        }
      },
      immediate: true
    },
    'ruleForm.googleCode': {
      handler(val) {
        if(val === '' || val === null) {
          this.visiGoogleMessage = true
        } else {
          this.visiGoogleMessage = false
        }
      },
      immediate: true
    }
  },
  methods: {
    // 选择验证类型
    handleCommand(e) {
      if(e.name === 'gm') {
        this.authType = this.$t('LoginFields.UserAuthenticator')
        this.showGoogleCodeInput = true
      }else {
        this.authType = this.$t('LoginFields.UserEmailRecover')
        this.showGoogleCodeInput = false
      }
    },
    // 請求驗證碼
    reqCode() {
    let loading = null;
      let data = {
        type: "get_email_code",
        code_type: "2fa",
        user_name: window.localStorage.getItem("user_name"),
      };
    return this.$refs.emailCodeCaptchaGuard.execute((captchaVerifyParam) => {
      const captchaParam = typeof captchaVerifyParam === "string"
        ? captchaVerifyParam
        : JSON.stringify(captchaVerifyParam);
      let formData = new URLSearchParams()
      for (let k in data) {
        formData.append(k, data[k]);
      }
      formData.append("captcha_verify_param", captchaParam);
      loading = Loading.service({ fullscreen: true });
      return this.$axios({
        method: "POST",
        url: "/request/user.php",
        // url: process.env.VUE_APP_BASE_URL+"/request/user.php",
        data: formData,
      });
    }, {
      isSuccess: (code) => Number(code.data.code) === 200,
    }).then((code) => {
      if (code.data.code == 200) {
        loading.close();
        this.$message.success(code.data.message);
        this.cellCode();
      } else {
        loading.close();
        this.timerNum = 0;
        clearInterval(this.timer);
        this.$message.error(code.data.message);
      }
    }).catch(() => {
      if (loading) loading.close();
    });
    },
    // 發送驗證碼
    cellCode() {
      // this.reqCode()
      this.dib = true;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.timerNum--;
        // this.vcode = this.timerNum
        this.getVc = this.timerNum;
        // this.$t('RegisterFields.SendCode2') = this.timerNum
        if (this.timerNum == 0) {
          clearInterval(this.timer);
          // this.vcode = this.rcode
          //  this.vcode = this.$t('RegisterFields.SendCode')
          // this.vcode = this.getVc
          this.timerNum = 60;
          this.dib = false;
        }
      }, 1000);
    },
    // 獲取賬戶餘額
    initAccountBalance() {
      const data = {
        type: 'get_account_balance',
        uid: localStorage.getItem("uid"),
      }
      getAccountBalance(data).then((res) => {
        if(res.code == 200) {
          this.account_balance = res.data
        } else {
          this.$message.error(res.message);
        }
      })
    },
    // 驗證提現金額
    validatorBala(val) {
      let reg = /^(\+)?\d+(\.\d+)?$/;
      if (val === null) {
        this.errorBackBala = "";
        this.flagsBala = false;
        return;
      }
      if(!reg.test(val)) {
        this.errorBackBala = this.$t("BankWithdrawal.InvalidAmount");
        this.flagsBala = true;
        return false;
      }
      else if(val <= 3) {
        this.errorBackBala = this.$t("BankWithdrawal.InvalidAmount");
        this.flagsBala = true;
        return false;
      }
      else {
        this.errorBackBala = "";
        this.flagsBala = false;
        return true;
      }
      // if (reg.test(val)) {
      //   this.errorBackBala = "";
      //   this.flagsBala = false;
      //   return true;
      // } 
      // if(val <= 3) {
      //   this.errorBackBala = this.$t("BankWithdrawal.InvalidAmount");
      //   this.flagsBala = true;
      //   return false;
      // }
      // else {
      //   this.errorBackBala = this.$t("BankWithdrawal.InvalidAmount");
      //   this.flagsBala = true;
      //   return false;
      // }
    },
    // 獲取*號前後字符
    extractParts(str) {
      if (str && str.length === 0) return;
      const starIndex = str.indexOf("*");
      const beforeStars = str.substring(0, starIndex);
      const afterStars = str.substring(starIndex + str.match(/\*/g).length);
      return { before: beforeStars, after: afterStars };
    },
    // 打開顯示所有地址窗口
    openAllAddressDialog() {
      this.dialogAddressVisible = true;
      // this.initAllAddressApi();
    },
    // 打開添加地址窗口
    openAddAddressDialog() {
      this.dialogAddAddressVisible = true;
    },
    // 點擊地址窗口選擇
    clickSelected(item) {
      this.dialogAddressVisible = false;
      this.wAddr = item.address;
      this.wAddrTag = item.tag
      this.limit_24h = item.limit_24h;
      this.limit_amount_24h = item.limit_amount_24h;
      this.available_limit_24h = item.available_limit_24h
      this.available_limit_amount_24h = item.available_limit_amount_24h
    },
    // 刪除API
    reqDeleteAddressApi(item) {
      const data = {
        type: "delete_withdraw_address",
        uid: localStorage.getItem("uid"),
        address: item.address,
      };
      deleteUSDTAddress(data).then((res) => {
        if (res.code == 200) {
          
          this.initAllAddressApi();
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 點擊刪除對於地址
    clickDeleted(item) {
      let that = this;
      this.$alert(
        `<div>
      <div style="margin-bottom:10px;">${this.$t(
        "WithdrawUSDT.ListAddress"
      )}: ${item.address}</div>
      <div>${this.$t("WithdrawUSDT.ListTag")}: ${item.tag}</div>
      </div>`,
        this.$t("WithdrawUSDT.DeleteTip"),
        {
          dangerouslyUseHTMLString: true,
          showCancelButton: true,
          cancelButtonText: this.$t("WithdrawUSDT.Cancel"),
          confirmButtonText: this.$t("WithdrawUSDT.Confirm"),
        }
      )
        .then(() => {
          // console.log("qd");
          if(that.wAddr == item.address) {
            this.wAddr = ''
          }
          that.reqDeleteAddressApi(item);
        })
        .catch(() => {
          console.log("qx");
        });
    },
    // 提取*號返回數組
    extractStars(str) {
      const stars = str.match(/\*/g) || [];
      return stars.map(() => "");
    },
    // 獲取地址數據
    initAllAddressApi(isFromAdd = false) {
      const data = {
        type: "get_withdraw_address",
        uid: localStorage.getItem("uid"),
      };
      // this.addressTableLoading = true
      allUSDTAddress(data)
        .then((res) => {
          if (res.code == 200) {
            this.allAddressData = res.data || res.data.data;
            this.addressTableLoading = false;
            // this.dialogAddressVisible = true;
            if (isFromAdd) {
              this.filterAddressItem(res.data);
              setTimeout(() => {
                this.dialogAddAddressVisible = false;
              }, 500);
            }
          } else {
            this.$message.error(res.message);
            this.addressTableLoading = false;
          }
        })
        .finally(() => {
          this.addressTableLoading = false;
        });
    },
    // 取消添加地址
    cancelAddAddress() {
      this.ruleForm.address = "";
      this.ruleForm.tag = "";
      this.ruleForm.code = '';
      this.ruleForm.googleCode = ''
      this.dialogAddAddressVisible = false;
      this.activeNameResetPwd = 'em'

      this.visiGoogleMessage = false
      this.visiEmailMessage = false
      this.visiTagMessage = false
    },
    //
    closeAddDialog() {
      this.dialogAddAddressVisible = false;
      this.step1 = true;
      this.ruleForm.address = "";
      this.ruleForm.tag = "";
      this.ruleForm.code = '';
      this.ruleForm.googleCode = ''
      this.activeNameResetPwd = 'em'
    },
    // 點擊下一步
    toNext() {
      // if (
      //   this.ruleForm.address == "" ||
      //   this.ruleForm.tag == "" ||
      //   this.flags ||
      //   this.tagFlag
      // ) {
      //   return;
      // }
      // if(this.activeNameResetPwd == 'em' && this.ruleForm.code == '') {
      //   return;
      // }
      // if(this.activeNameResetPwd == 'gm' && this.ruleForm.googleCode == '') {
      //   return;
      // }

      if(this.ruleForm.address == '' || this.flags) {
        this.errorBackAddress = this.$t('WithdrawUSDT.Required')
        // return;
      }
      if(this.ruleForm.tag == '') {
        this.visiTagMessage = true
        this.tagErrorMessage = this.$t('WithdrawUSDT.Required')
        // return;
      }
      if(this.activeNameResetPwd == 'em' && this.ruleForm.code == '') {
        console.log('em')
        this.visiEmailMessage = true
        this.emailErrorMessage = this.$t('WithdrawUSDT.Required')
        return;
      }
      if(this.activeNameResetPwd == 'gm' && this.ruleForm.googleCode == '') {
        console.log('gm')
        this.visiGoogleMessage = true
        this.googleErrorMessage = this.$t('WithdrawUSDT.Required')
        return;
      }
      this.visiTagMessage = false
      this.visiEmailMessage = false
      this.visiGoogleMessage = false

      const obj = {
        type: "add_user_withdraw_address",
        uid: localStorage.getItem("uid"),
        address: this.ruleForm.address,
        tag: this.ruleForm.tag,
      };
      const data = this.activeNameResetPwd == 'em' ? { ...obj, email_code: this.ruleForm.code } : { ...obj, google_code: this.ruleForm.googleCode }
      return this.$refs.addWithdrawAddressCaptchaGuard.execute((captchaVerifyParam) => {
        return addUSDTAddress({
          ...data,
          captcha_verify_param: captchaVerifyParam
        })
      }, {
        isSuccess: (res) => Number(res.code) === 200
      }).then((res) => {
        console.log("add res", res);
        if (res.code == 200) {
          this.addr_id = res.data.addr_id;
          this.masked_addr = res.data.masked_addr;
          this.step1 = false;
          this.inputChars = this.extractStars(res.data.masked_addr);
        } else {
          this.$message.error(res.message);
        }
      }).catch(() => {});
    },
    // 提交添加地址
    submitAddAddress() {
      if (this.inputChars.join("") == "") {
        return;
      }
      const data = {
        type: "verify_withdraw_address",
        uid: localStorage.getItem("uid"),
        addr_id: this.addr_id,
        verify_char: this.inputChars.join(""),
      };
      verifyUSDTAddress(data).then((res) => {
        console.log("sub add res", res);
        if (res.code == 200) {
          this.wAddr = this.ruleForm.address;
          this.initAllAddressApi(true);

          // this.masked_addr = ''
          // this.addr_id = ''

          this.$message.success(res.message);
          // setTimeout(() => {
          //   this.dialogAddAddressVisible = false
          // }, 500)
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 驗證標簽
    validatorTag(val) {
      const regex =
        /^[\u4e00-\u9fa5\sA-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
      if (val === "") {
        this.errorBackTag = "";
        this.tagFlag = false;
        return;
      }
      if (regex.test(val)) {
        this.errorBackTag = "";
        this.tagFlag = false;
        return true;
      } else {
        this.errorBackTag = this.$t("VirtualCard.Create.InvalidTag");
        this.tagFlag = true;
        return false;
      }
    },
    validatorAddress(val) {
      // let reg = /^T.*/;
      let reg = /^T[1-9A-HJ-NP-Za-km-z]{33}$/;
      if (val === "") {
        this.errorBackAddress = "";
        this.flags = false;
        return;
      }
      if (reg.test(val)) {
        this.errorBackAddress = "";
        this.flags = false;
        return true;
      } else {
        this.errorBackAddress = this.$t(
          "RewardCenter.BindUSDTAcc.InvalidAddress"
        );
        this.flags = true;
        return false;
      }
    },
    // 计算需要隐藏的部分
    calculateHiddenPart() {
      // 首先验证地址长度是否为34位
      if (this.fullAddress.length !== 34) {
        console.warn(
          "警告：Tron地址应为34位，当前地址长度为：",
          this.fullAddress.length
        );
      }

      this.hiddenChars = this.fullAddress.substring(
        this.hiddenStartIndex,
        this.hiddenEndIndex
      );

      // 更新输入框数量以匹配隐藏字符的数量
      this.inputChars = Array(this.hiddenCharsCount).fill("");
    },
    // 处理输入事件
    onInput(index) {
      // 确保输入为当前格式（无需强制大写，保持原始格式）
      if (this.inputChars[index].length > 0) {
        // 自动跳到下一个输入框
        if (index < this.hiddenCharsCount - 1) {
          this.$nextTick(() => {
            // console.log('this.$refs', this.$refs.charInputs[index + 1])
            this.$refs.charInputs[index + 1].focus();
          });
        }
      }
    },
    // 過濾地址顯
    filterAddressItem(data) {
      console.log("filter", data);
      console.log("this.ruleForm.address", this.ruleForm.address);
      const filterData = data.filter(
        (item) => item.address === this.ruleForm.address
      );
      console.log("filterData", filterData);
      this.limit_24h = filterData[0]?.limit_24h;
      this.limit_amount_24h = filterData[0]?.limit_amount_24h;
      this.wAddrTag = filterData[0]?.tag
      this.available_limit_24h = filterData[0]?.available_limit_24h
      this.available_limit_amount_24h = filterData[0]?.available_limit_amount_24h
      // return filterData;
    },
    // 处理按键事件
    handleKeyDown(event, index) {
      // 按下退格键时，如果当前输入框为空，则焦点移至前一个输入框
      if (
        event.key === "Backspace" &&
        this.inputChars[index] === "" &&
        index > 0
      ) {
        this.$nextTick(() => {
          this.$refs.charInputs[index - 1].focus();
        });
      }
    },
    // 验证地址
    verifyAddress() {
      const userInput = this.inputChars.join("");

      if (userInput === this.hiddenChars) {
        this.message = "地址驗證成功！";
        this.isSuccess = true;
      } else {
        this.message = "地址驗證失敗，請檢查輸入是否正確。";
        this.isSuccess = false;
      }
    },
    // 设置新的地址
    setNewAddress(newAddress) {
      if (newAddress.length !== 34) {
        console.error("错误：Tron地址必须为34位");
        return;
      }

      this.fullAddress = newAddress;
      this.calculateHiddenPart();
      this.message = ""; // 清除之前的验证消息
    },
    submitUSDT() {
      if(this.wAddr == "") {
        this.addressNoneTip = true
        return;
      }
      if (
        this.wAddr == "" ||
        this.wBalance == null ||
        this.flagsBala ||
        this.flagsReBalance
      ) {
        return;
      }
      this.addressNoneTip = false
      let data = {
        type: "withdraw",
        uid: localStorage.getItem("uid"),
        amount: this.wBalance,
        pay_way: "USDT",
        account: this.wAddr,
      };
      return this.$refs.withdrawCaptchaGuard.execute((captchaVerifyParam) => {
        return withdraw({
          ...data,
          captcha_verify_param: captchaVerifyParam
        })
      }, {
        isSuccess: (res) => Number(res.code) === 200
      }).then((res) => {
        if (res.code == 200) {
          // this.wAddr = "";
          this.wBalance = null;
          this.$message.success(res.message);
          this.$router.push("/card-detail/account-flow");
        } else {
          this.$message.error(res.message);
        }
      }).catch(() => {});
    },
  },
};
</script>

<style>
.brd {
  border-radius: 8px;
}
</style>
<style scoped>
/* 横幅容器 - 高度缩小30% */
.form-banner {
  /* width: 875px; */
  height: 60px;
  /* 渐变背景色 */
  background: linear-gradient(90deg, #007bff, #1e90ff, #00bfff);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: 55%;
  position: absolute;
  z-index: 2;
  left: calc(50% - -20px);
  top: -32px;
  transform: translateX(-50%);
}

/* 广告语样式 */
.banner-slogan {
  color: white;
  font-size: 1.2rem;
  font-weight: 700;
  text-align: center;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
  padding: 0 20px;
  letter-spacing: 1.5px;
  line-height: 1.4; /* 增加行高以适应两行文本 */
}

/* 第二行样式 */
.second-line {
  display: block; /* 确保换行显示 */
  margin-top: 4px; /* 增加行间距 */
  font-size: 0.9rem; /* 缩小字体大小 */
}
.address-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px 0;
  font-size: 14px;
  /* flex-wrap: wrap; */
}
.address-part {
  color: #333;
  word-break: break-all;
  font-family: monospace;
}
.input-boxes {
  display: flex;
  gap: 5px;
  margin: 0 5px;
}
.char-input {
  width: 32px;
  height: 32px;
  text-align: center;
  font-size: 20px;
  border: 2px solid #e8e8e8;
  border-radius: 4px;
  outline: none;
  font-family: monospace;
}
.char-input:focus {
  /* border-color: #ff0000; */
  /* box-shadow: 0 0 5px rgba(255, 0, 0, 0.3); */
  color: #768192;
  background-color: #fff;
  border-color: #958bef;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25);
  box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25);
}
.verification-button {
  display: block;
  width: 100%;
  padding: 12px;
  background-color: #ff3333;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 20px;
}
.verification-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}
.message {
  margin-top: 15px;
  text-align: center;
  font-weight: bold;
}
.success {
  color: #2ecc71;
}
.error {
  color: #e74c3c;
}
.address-info {
  text-align: center;
  margin-top: 10px;
  font-size: 14px;
  color: #666;
}
.fl {
  display: flex;
  gap: 10px;
}
@media (max-width: 480px) {
  .address-container {
    flex-direction: column;
    gap: 10px;
  }
  .address-part,
  .input-boxes {
    font-size: 16px;
  }
  .char-input {
    width: 35px;
    height: 35px;
    font-size: 16px;
  }
}
.wd-btnbox {
  display: flex;
  gap: 6px;
  align-items: center;
  /* margin-left: 5rem; */
}
.acvals {
  width: 183px;
  text-align: right;
}
.withdraw-usdt {
  padding-left: 2.6rem;
}
.c-wrper {
  width: 50%;
  margin: 2.2rem auto;
}
/* @media (min-width: 1366px) and (max-width: 1599px) {
  .c-wrper {
    width: 100%;
  }
} */

/* 小屏筆記本（≤1365px） */
@media (max-width: 1365px) {
  .c-wrper {
    width: 100%;
  }
  .form-banner {
    width: 100%;
  }
}

@media (max-width: 770px) {
  .c-wrper {
    width: 100%;
  }
  /* .brd {
    width: 100%;
  } */
}
.fitem {
  display: flex;
  align-items: center;
  /* padding: 1rem 0.5rem; */
  justify-content: space-between;
  gap: 30px;
  padding: 15px 5px;
  border-bottom: 1px solid #eee;
}
.fitem:last-child {
  border-bottom: 0;
}
.flb {
  width: 200px;
  font-weight: 500;
  color: #42474d;
  font-size: 14px;
  text-align: right;
  font-family: AxLLCircular, Helvetica, Arialsans-serif;
}
.vals {
  color: #42474d;
  font-size: 14px;
  font-family: AxLLCircular, Helvetica, Arialsans-serif;
}
.tip {
  color: #e6a23c;
  font-weight: bold;
  font-size: 12px;
  margin-left: 0.3rem;
}
.inp {
  margin-left: 1rem;
}
.form-group {
  margin: 0 !important;
  /* margin-left: 5rem !important; */
}
.sbtn:hover {
  background: rgba(0, 190, 164, 0.8) !important;
}
.sbtn:focus {
  border-color: #00bea4;
  box-shadow: 0 0 0 0.25rem rgba(0, 190, 164, 0.5) !important;
}
.custer {
  background: #00bea4;
  color: #fff;
  width: 100%;
  outline: 0;
}
</style>
